import { Button } from '@material-ui/core'
import { Checkbox, PopupLoader } from 'components'
import * as React from 'react'
import {
  Link as RouteLink,
  RouteComponentProps,
  withRouter
} from 'react-router-dom'
import { _route } from '../../routes/config'
import ParentForm from './Parent/form'

export interface INativeProps {
  onChangeMaskedInput: any
  isAnyTouched?: boolean
  isValidForm?: boolean
  userRole: string
  loading: boolean
  onSubmit: any
  page: string
  formSubmitted: boolean
  agreeWithTerms: boolean
  setAgreeWithTerms: (v: boolean) => void
}

export interface IProps extends INativeProps, RouteComponentProps {}

class Content extends React.PureComponent<IProps> {
  getForm = (role: string = 'parent') => {
    const { onChangeMaskedInput } = this.props
    switch (role) {
      case 'parent':
        return <ParentForm onChangeMaskedInput={onChangeMaskedInput} />
      default:
        return null
    }
  }

  stopPropagation = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
    event.stopPropagation()

  renderFormPage = () => {
    const {
      isAnyTouched,
      isValidForm,
      formSubmitted,
      onSubmit,
      userRole,
      agreeWithTerms,
      setAgreeWithTerms
    } = this.props
    return (
      <div className="create-password-container">
        <div className="signup-page-content design-fixes">
          <div className="signup-page-title">Create a password</div>
          <div className="subtitle">
            Last step and you’re ready to go!
            <br />
            We hate paperwork too...
          </div>
          <div className="form-container">
            {this.getForm(userRole)}

            <div
              className={`agree-with-temrs-wrapper ${
                agreeWithTerms ? '' : 'un'
              }checked`}
              onClick={() => setAgreeWithTerms(!agreeWithTerms)}
            >
              <Checkbox value={agreeWithTerms} />
              <div className="agree-text">
                I agree to the{' '}
                <a
                  href="https://www.giantleap.tech/terms"
                  target="_blank"
                  className="agree-link link"
                  onClick={this.stopPropagation}
                >
                  Terms of Use{' '}
                </a>
                and{' '}
                <a
                  href="https://www.giantleap.tech/privacy"
                  target="_blank"
                  className="agree-link link"
                  onClick={this.stopPropagation}
                >
                  Privacy Policy
                </a>
              </div>
            </div>

            {isAnyTouched && !isValidForm && formSubmitted && (
              <div className="error">Must fill all parameters</div>
            )}
          </div>
          <div className="btn-wrapper">
            <Button
              className={`signup-button ${
                !isValidForm ? 'disabled' : 'active'
              }`}
              onClick={onSubmit}
              id="1-join-a"
            >
              Join GiantLeap
            </Button>
          </div>
          <div className="link-to-log-in">
            <div className="text">Already have an account? </div>
            <RouteLink to={_route.login} className="link">
              Sign in
            </RouteLink>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { page, loading } = this.props

    return (
      <>
        {page === 'form' ? this.renderFormPage() : null}
        <PopupLoader active={loading} />
      </>
    )
  }
}

export default withRouter(Content)



// WEBPACK FOOTER //
// ./src/pages/CreatePassword/content.tsx